// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════
   Roles & Permissions screen
   ════════════════════════════════════════════════════════ */

.rp-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8fafc;
  font-family: inherit;
}

/* ── Header ─────────────────────────────────────────────── */
.rp-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: #fff;
  border-bottom: 1.5px solid #e2e8f0;
  flex-shrink: 0;
}

.rp-back {
  width: 32px;
  height: 32px;
  border: 1.5px solid #e2e8f0;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  flex-shrink: 0;
  transition: border-color 0.15s, background 0.15s;
}
.rp-back:hover { background: #f1f5f9; border-color: #cbd5e1; }

.rp-header-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.rp-header-sub {
  font-size: 11.5px;
  color: #64748b;
  margin: 1px 0 0;
}

/* ── Scroll body ─────────────────────────────────────────── */
.rp-body {
  flex: 1;
  overflow-y: auto;
  padding: 18px 20px 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Generic card ────────────────────────────────────────── */
.rp-card {
  background: #fff;
  border-radius: 14px;
  border: 1.5px solid #e2e8f0;
  overflow: hidden;
}

/* ── Section label above card ────────────────────────────── */
.rp-section-label {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.1em;
  color: #94a3b8;
  text-transform: uppercase;
  margin: 0 0 6px 2px;
}

/* ── Card inner header row ───────────────────────────────── */
.rp-card-inner-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
}
.rp-card-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.rp-card-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.rp-card-sub {
  font-size: 11px;
  color: #64748b;
  margin: 1px 0 0;
}

/* ── Divider ─────────────────────────────────────────────── */
.rp-divider { height: 1px; background: #f1f5f9; margin: 0; }

/* ── Role pills ──────────────────────────────────────────── */
.rp-roles-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 16px 14px;
}
.rp-role-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.rp-no-roles {
  font-size: 12px;
  color: #94a3b8;
  font-style: italic;
  padding: 0;
}
.rp-roles-loading {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12px;
  color: #64748b;
}
.rp-roles-err {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-style: normal;
  color: #ef4444 !important;
}

/* ── Permission legend ───────────────────────────────────── */
.rp-perm-legend {
  display: flex;
  gap: 16px;
  padding: 10px 16px 12px;
}
.rp-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.rp-legend-label {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}

/* ── Perm badge (26×26 square) ──────────────────────────── */
.rp-perm-badge {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10.5px;
  font-weight: 700;
  flex-shrink: 0;
}

/* ── Accordion ───────────────────────────────────────────── */
.rp-accordion-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  gap: 10px;
  text-align: left;
}
.rp-accordion-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.rp-accordion-body {
  border-top: 1.5px solid #f1f5f9;
}

/* ── Timeline ────────────────────────────────────────────── */
.rp-timeline {
  padding: 12px 16px 6px;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.rp-tl-item {
  display: flex;
  gap: 12px;
  padding-bottom: 14px;
}
.rp-tl-connector {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 14px;
}
.rp-tl-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2a71ff;
  border: 2px solid #dbeafe;
  flex-shrink: 0;
  margin-top: 3px;
}
.rp-tl-line {
  flex: 1;
  width: 2px;
  background: #e2e8f0;
  margin-top: 4px;
}
.rp-tl-content { flex: 1; min-width: 0; padding-bottom: 4px; }
.rp-tl-row1 { display: flex; align-items: center; gap: 8px; margin-bottom: 3px; }
.rp-tl-badge {
  background: #dbeafe;
  color: #1d4ed8;
  border-radius: 999px;
  padding: 2px 9px;
  font-size: 10.5px;
  font-weight: 700;
}
.rp-tl-platform { font-size: 11.5px; color: #475569; font-weight: 500; }
.rp-tl-date { font-size: 12.5px; font-weight: 600; color: #0f172a; margin: 0 0 2px; }
.rp-tl-expiry { font-size: 10.5px; color: #94a3b8; margin: 0; }

.rp-tl-loading, .rp-tl-error, .rp-tl-empty {
  padding: 20px 16px;
  text-align: center;
  font-size: 12.5px;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.rp-tl-error { color: #ef4444; }

/* ── Resource permissions ────────────────────────────────── */
.rp-perm-empty {
  padding: 28px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #94a3b8;
}
.rp-perm-empty-icon {
  width: 44px;
  height: 44px;
  background: #f1f5f9;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rp-perm-empty p {
  font-size: 12px;
  color: #64748b;
  text-align: center;
  max-width: 280px;
  line-height: 1.6;
  margin: 0;
}

.rp-cat-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  background: transparent;
  border: none;
  cursor: pointer;
  border-bottom: 1.5px solid #f1f5f9;
  gap: 8px;
  text-align: left;
}
.rp-cat-btn:last-of-type { border-bottom: none; }
.rp-cat-left { display: flex; align-items: center; gap: 10px; min-width: 0; flex: 1; }
.rp-cat-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.rp-cat-label { font-size: 12.5px; font-weight: 600; color: #0f172a; flex: 1; min-width: 0; }
.rp-cat-count {
  background: #f1f5f9;
  color: #64748b;
  border-radius: 999px;
  padding: 1px 7px;
  font-size: 10.5px;
  font-weight: 700;
  flex-shrink: 0;
}

.rp-cat-resources {
  padding: 4px 0;
  border-top: 1.5px solid #f8fafc;
}
.rp-perm-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  gap: 12px;
  border-bottom: 1px solid #f8fafc;
}
.rp-perm-row:last-child { border-bottom: none; }
.rp-resource-name {
  font-size: 12px;
  color: #334155;
  font-weight: 500;
  flex: 1;
  min-width: 0;
}
.rp-perm-flags { display: flex; gap: 4px; flex-shrink: 0; }

/* ── Session & Security ──────────────────────────────────── */
.rp-sec-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 13px 16px;
  position: relative;
}
.rp-sec-row + .rp-sec-row { border-top: 1.5px solid #f8fafc; }
.rp-sec-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}
.rp-sec-content { flex: 1; min-width: 0; }
.rp-sec-label { font-size: 11px; color: #94a3b8; font-weight: 500; margin: 0 0 2px; text-transform: uppercase; letter-spacing: 0.04em; }
.rp-sec-value { font-size: 13px; font-weight: 600; color: #0f172a; margin: 0; }
.rp-sec-sub { font-size: 11px; color: #94a3b8; margin: 2px 0 0; }
.rp-sec-action {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  flex-shrink: 0;
  margin-top: 4px;
  transition: background 0.15s, border-color 0.15s;
}
.rp-sec-action:hover { background: #f1f5f9; border-color: #cbd5e1; }

/* ── Dark mode ───────────────────────────────────────────── */
.dark .rp-container { background: #1a1f2e; }
.dark .rp-header { background: #242939; border-color: #374151; }
.dark .rp-header-title { color: #f1f5f9; }
.dark .rp-header-sub { color: #94a3b8; }
.dark .rp-back { background: #2d3447; border-color: #374151; color: #94a3b8; }
.dark .rp-card { background: #242939; border-color: #374151; }
.dark .rp-card-title { color: #f1f5f9; }
.dark .rp-card-sub { color: #94a3b8; }
.dark .rp-divider { background: #374151; }
.dark .rp-section-label { color: #64748b; }
.dark .rp-cat-label { color: #f1f5f9; }
.dark .rp-resource-name { color: #cbd5e1; }
.dark .rp-sec-value { color: #f1f5f9; }
.dark .rp-sec-row + .rp-sec-row { border-color: #374151; }
.dark .rp-perm-row { border-color: #2d3447; }
.dark .rp-cat-btn { border-color: #374151; }
.dark .rp-cat-resources { border-color: #374151; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/RolesPermissions/index.css"],"names":[],"mappings":"AAAA;;6DAE6D;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,gDAAgD;AAClD;AACA,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE;;AAE7D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,+DAA+D;AAC/D,cAAc,WAAW,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAE3D,+DAA+D;AAC/D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,+BAA+B;AACjC;;AAEA,+DAA+D;AAC/D;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;AACA;EACE,OAAO;EACP,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;AACA,iBAAiB,OAAO,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC7D,cAAc,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAChF;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA,kBAAkB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACvE,cAAc,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AACpF,gBAAgB,iBAAiB,EAAE,cAAc,EAAE,SAAS,EAAE;;AAE9D;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA,eAAe,cAAc,EAAE;;AAE/B,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,QAAQ;EACR,gBAAgB;AAClB;AACA,2BAA2B,mBAAmB,EAAE;AAChD,eAAe,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,YAAY,EAAE,OAAO,EAAE;AACrF;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,gBAAgB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,OAAO,EAAE,YAAY,EAAE;AAC5F;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;EACT,gCAAgC;AAClC;AACA,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,OAAO;EACP,YAAY;AACd;AACA,iBAAiB,aAAa,EAAE,QAAQ,EAAE,cAAc,EAAE;;AAE1D,+DAA+D;AAC/D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;AACA,4BAA4B,+BAA+B,EAAE;AAC7D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA,kBAAkB,OAAO,EAAE,YAAY,EAAE;AACzC,gBAAgB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACvI,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AAC9E,cAAc,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAChE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gDAAgD;AAClD;AACA,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;;AAEnE,+DAA+D;AAC/D,sBAAsB,mBAAmB,EAAE;AAC3C,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE;AAC/D,yBAAyB,cAAc,EAAE;AACzC,uBAAuB,cAAc,EAAE;AACvC,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC7E,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE;AAC7D,uBAAuB,cAAc,EAAE;AACvC,qBAAqB,cAAc,EAAE;AACrC,oBAAoB,mBAAmB,EAAE;AACzC,0BAA0B,cAAc,EAAE;AAC1C,sBAAsB,cAAc,EAAE;AACtC,0BAA0B,cAAc,EAAE;AAC1C,sBAAsB,cAAc,EAAE;AACtC,kCAAkC,qBAAqB,EAAE;AACzD,qBAAqB,qBAAqB,EAAE;AAC5C,oBAAoB,qBAAqB,EAAE;AAC3C,0BAA0B,qBAAqB,EAAE","sourcesContent":["/* ════════════════════════════════════════════════════════\n   Roles & Permissions screen\n   ════════════════════════════════════════════════════════ */\n\n.rp-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #f8fafc;\n  font-family: inherit;\n}\n\n/* ── Header ─────────────────────────────────────────────── */\n.rp-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #fff;\n  border-bottom: 1.5px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.rp-back {\n  width: 32px;\n  height: 32px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 50%;\n  background: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #475569;\n  flex-shrink: 0;\n  transition: border-color 0.15s, background 0.15s;\n}\n.rp-back:hover { background: #f1f5f9; border-color: #cbd5e1; }\n\n.rp-header-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n.rp-header-sub {\n  font-size: 11.5px;\n  color: #64748b;\n  margin: 1px 0 0;\n}\n\n/* ── Scroll body ─────────────────────────────────────────── */\n.rp-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 18px 20px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Generic card ────────────────────────────────────────── */\n.rp-card {\n  background: #fff;\n  border-radius: 14px;\n  border: 1.5px solid #e2e8f0;\n  overflow: hidden;\n}\n\n/* ── Section label above card ────────────────────────────── */\n.rp-section-label {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n  text-transform: uppercase;\n  margin: 0 0 6px 2px;\n}\n\n/* ── Card inner header row ───────────────────────────────── */\n.rp-card-inner-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n}\n.rp-card-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.rp-card-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n.rp-card-sub {\n  font-size: 11px;\n  color: #64748b;\n  margin: 1px 0 0;\n}\n\n/* ── Divider ─────────────────────────────────────────────── */\n.rp-divider { height: 1px; background: #f1f5f9; margin: 0; }\n\n/* ── Role pills ──────────────────────────────────────────── */\n.rp-roles-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 4px 16px 14px;\n}\n.rp-role-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.rp-no-roles {\n  font-size: 12px;\n  color: #94a3b8;\n  font-style: italic;\n  padding: 0;\n}\n.rp-roles-loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 12px;\n  color: #64748b;\n}\n.rp-roles-err {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-style: normal;\n  color: #ef4444 !important;\n}\n\n/* ── Permission legend ───────────────────────────────────── */\n.rp-perm-legend {\n  display: flex;\n  gap: 16px;\n  padding: 10px 16px 12px;\n}\n.rp-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.rp-legend-label {\n  font-size: 11px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n/* ── Perm badge (26×26 square) ──────────────────────────── */\n.rp-perm-badge {\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10.5px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n/* ── Accordion ───────────────────────────────────────────── */\n.rp-accordion-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  gap: 10px;\n  text-align: left;\n}\n.rp-accordion-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.rp-accordion-body {\n  border-top: 1.5px solid #f1f5f9;\n}\n\n/* ── Timeline ────────────────────────────────────────────── */\n.rp-timeline {\n  padding: 12px 16px 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.rp-tl-item {\n  display: flex;\n  gap: 12px;\n  padding-bottom: 14px;\n}\n.rp-tl-connector {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n  width: 14px;\n}\n.rp-tl-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #2a71ff;\n  border: 2px solid #dbeafe;\n  flex-shrink: 0;\n  margin-top: 3px;\n}\n.rp-tl-line {\n  flex: 1;\n  width: 2px;\n  background: #e2e8f0;\n  margin-top: 4px;\n}\n.rp-tl-content { flex: 1; min-width: 0; padding-bottom: 4px; }\n.rp-tl-row1 { display: flex; align-items: center; gap: 8px; margin-bottom: 3px; }\n.rp-tl-badge {\n  background: #dbeafe;\n  color: #1d4ed8;\n  border-radius: 999px;\n  padding: 2px 9px;\n  font-size: 10.5px;\n  font-weight: 700;\n}\n.rp-tl-platform { font-size: 11.5px; color: #475569; font-weight: 500; }\n.rp-tl-date { font-size: 12.5px; font-weight: 600; color: #0f172a; margin: 0 0 2px; }\n.rp-tl-expiry { font-size: 10.5px; color: #94a3b8; margin: 0; }\n\n.rp-tl-loading, .rp-tl-error, .rp-tl-empty {\n  padding: 20px 16px;\n  text-align: center;\n  font-size: 12.5px;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n.rp-tl-error { color: #ef4444; }\n\n/* ── Resource permissions ────────────────────────────────── */\n.rp-perm-empty {\n  padding: 28px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  color: #94a3b8;\n}\n.rp-perm-empty-icon {\n  width: 44px;\n  height: 44px;\n  background: #f1f5f9;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.rp-perm-empty p {\n  font-size: 12px;\n  color: #64748b;\n  text-align: center;\n  max-width: 280px;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.rp-cat-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 11px 14px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  border-bottom: 1.5px solid #f1f5f9;\n  gap: 8px;\n  text-align: left;\n}\n.rp-cat-btn:last-of-type { border-bottom: none; }\n.rp-cat-left { display: flex; align-items: center; gap: 10px; min-width: 0; flex: 1; }\n.rp-cat-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.rp-cat-label { font-size: 12.5px; font-weight: 600; color: #0f172a; flex: 1; min-width: 0; }\n.rp-cat-count {\n  background: #f1f5f9;\n  color: #64748b;\n  border-radius: 999px;\n  padding: 1px 7px;\n  font-size: 10.5px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.rp-cat-resources {\n  padding: 4px 0;\n  border-top: 1.5px solid #f8fafc;\n}\n.rp-perm-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 14px;\n  gap: 12px;\n  border-bottom: 1px solid #f8fafc;\n}\n.rp-perm-row:last-child { border-bottom: none; }\n.rp-resource-name {\n  font-size: 12px;\n  color: #334155;\n  font-weight: 500;\n  flex: 1;\n  min-width: 0;\n}\n.rp-perm-flags { display: flex; gap: 4px; flex-shrink: 0; }\n\n/* ── Session & Security ──────────────────────────────────── */\n.rp-sec-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 13px 16px;\n  position: relative;\n}\n.rp-sec-row + .rp-sec-row { border-top: 1.5px solid #f8fafc; }\n.rp-sec-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n.rp-sec-content { flex: 1; min-width: 0; }\n.rp-sec-label { font-size: 11px; color: #94a3b8; font-weight: 500; margin: 0 0 2px; text-transform: uppercase; letter-spacing: 0.04em; }\n.rp-sec-value { font-size: 13px; font-weight: 600; color: #0f172a; margin: 0; }\n.rp-sec-sub { font-size: 11px; color: #94a3b8; margin: 2px 0 0; }\n.rp-sec-action {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: 1.5px solid #e2e8f0;\n  background: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n  flex-shrink: 0;\n  margin-top: 4px;\n  transition: background 0.15s, border-color 0.15s;\n}\n.rp-sec-action:hover { background: #f1f5f9; border-color: #cbd5e1; }\n\n/* ── Dark mode ───────────────────────────────────────────── */\n.dark .rp-container { background: #1a1f2e; }\n.dark .rp-header { background: #242939; border-color: #374151; }\n.dark .rp-header-title { color: #f1f5f9; }\n.dark .rp-header-sub { color: #94a3b8; }\n.dark .rp-back { background: #2d3447; border-color: #374151; color: #94a3b8; }\n.dark .rp-card { background: #242939; border-color: #374151; }\n.dark .rp-card-title { color: #f1f5f9; }\n.dark .rp-card-sub { color: #94a3b8; }\n.dark .rp-divider { background: #374151; }\n.dark .rp-section-label { color: #64748b; }\n.dark .rp-cat-label { color: #f1f5f9; }\n.dark .rp-resource-name { color: #cbd5e1; }\n.dark .rp-sec-value { color: #f1f5f9; }\n.dark .rp-sec-row + .rp-sec-row { border-color: #374151; }\n.dark .rp-perm-row { border-color: #2d3447; }\n.dark .rp-cat-btn { border-color: #374151; }\n.dark .rp-cat-resources { border-color: #374151; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
